<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Add News</h4>
      </div>
      <div class="modal-body">
        <div class="form-group mb-3">
          <label>Name</label>
          <input class="form-control" [(ngModel)]="name" placeholder="News name" type="text">
        </div>
        <div class="row mb-3">
          <div class="col-sm-6">
            <div class="form-group">
              <label>Start Date</label>
              <input class="form-control" [(ngModel)]="startDate" type="datetime-local">
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label>End Date</label>
              <input class="form-control" [(ngModel)]="endDate" type="datetime-local">
            </div>
          </div>
        </div>
        <div class="form-check mb-2">
          <input class="form-check-input" type="checkbox" [(ngModel)]="isActive" id="isActiveAdd">
          <label class="form-check-label" for="isActiveAdd">Active</label>
        </div>
        <div class="form-check mb-3">
          <input class="form-check-input" type="checkbox" [(ngModel)]="isRate" id="isRateAdd">
          <label class="form-check-label" for="isRateAdd">Rate</label>
        </div>
        <div class="row mb-3">
          <div class="col-sm-6">
            <div class="form-group">
              <label>User Created After</label>
              <input class="form-control" [(ngModel)]="userCreatedAfterDate" type="datetime-local">
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label>User Created Before</label>
              <input class="form-control" [(ngModel)]="userCreatedBeforeDate" type="datetime-local">
            </div>
          </div>
        </div>

        <hr/>
        <!-- PERIODICITY -->
        <div class="mb-3">
          <div class="form-check form-switch mb-2">
            <input class="form-check-input" type="checkbox" [(ngModel)]="periodicity.enabled" id="periodicityEnabledAdd">
            <label class="form-check-label fw-semibold" for="periodicityEnabledAdd">Periodicity</label>
          </div>
          @if (periodicity.enabled) {
            <div class="card card-body bg-light">
              <div class="form-group mb-2">
                <label>Type</label>
                <select class="form-control" [(ngModel)]="periodicity.type">
                  @for (t of periodicityTypes; track t.value) {
                    <option [ngValue]="t.value">{{ t.label }}</option>
                  }
                </select>
              </div>
              @if (periodicity.type === NewsPeriodicityType.Weekly) {
                <div class="mb-2">
                  <label>Days</label>
                  <div class="d-flex gap-1 flex-wrap">
                    @for (day of weekDays; track $index; let i = $index) {
                      <button type="button" class="btn btn-sm" [class.btn-primary]="isWeekDayActive(i)" [class.btn-secondary]="!isWeekDayActive(i)" (click)="toggleWeekDay(i)">{{ day }}</button>
                    }
                  </div>
                </div>
              }
              @if (periodicity.type === NewsPeriodicityType.Monthly) {
                <div class="row mb-2">
                  <div class="col-6">
                    <label>Day Start</label>
                    <input type="number" class="form-control" [(ngModel)]="periodicity.dayStart" min="1" max="31">
                  </div>
                  <div class="col-6">
                    <label>Day End</label>
                    <input type="number" class="form-control" [(ngModel)]="periodicity.dayEnd" min="1" max="31">
                  </div>
                </div>
              }
              <div class="row">
                <div class="col-6">
                  <label>Time Start</label>
                  <input type="time" class="form-control" [(ngModel)]="periodicity.timeStart">
                </div>
                <div class="col-6">
                  <label>Time End</label>
                  <input type="time" class="form-control" [(ngModel)]="periodicity.timeEnd">
                </div>
              </div>
            </div>
          }
        </div>

        <hr/>
        <!-- LINKS -->
        <div class="card mb-3">
          <div class="card-header py-2 d-flex justify-content-between align-items-center" style="cursor:pointer" (click)="toggleLinks()">
            <strong>Links</strong>
            <i class="fa" [class.fa-chevron-down]="!linksCollapsed" [class.fa-chevron-left]="linksCollapsed"></i>
          </div>
          @if (!linksCollapsed) {
            <div class="card-body">
              <div class="form-group mb-2">
                <label>Link Default</label>
                <input class="form-control" [(ngModel)]="linkDefault" placeholder="Default link" type="text">
              </div>
              <div class="form-group mb-2">
                <label>Link iOS</label>
                <input class="form-control" [(ngModel)]="linkIos" placeholder="iOS link" type="text">
              </div>
              <div class="form-group mb-0">
                <label>Link Android</label>
                <input class="form-control" [(ngModel)]="linkAndroid" placeholder="Android link" type="text">
              </div>
            </div>
          }
        </div>

        <hr/>
        <div class="form-group mb-3">
          <label>Predefined Template</label>
          <select class="form-control" [(ngModel)]="selectedPredefinedId" (ngModelChange)="onPredefinedChange()">
            <option [ngValue]="0">— None —</option>
            @for (p of predefinedList; track p.newsPredefinedId) {
              <option [ngValue]="p.newsPredefinedId">{{ p.name }}</option>
            }
          </select>
        </div>
        @if (!translationsFromPredefined) {
          <h6>Translations</h6>
          @for (t of translations; track t.languageId) {
            <div class="card mb-2">
              <div class="card-header py-2 d-flex justify-content-between align-items-center" style="cursor:pointer" (click)="toggleTranslation(t)">
                <strong>{{ t.languageIso }}</strong>
                <i class="fa" [class.fa-chevron-down]="!t.isCollapsed" [class.fa-chevron-left]="t.isCollapsed"></i>
              </div>
              @if (!t.isCollapsed) {
                <div class="card-body">
                  <div class="form-group mb-2">
                    <label>Title</label>
                    <input class="form-control" [(ngModel)]="t.title" (ngModelChange)="onTranslationChanged()" placeholder="Title" type="text">
                  </div>
                  <div class="form-group mb-2">
                    <label>Summary</label>
                    <textarea class="form-control" [(ngModel)]="t.summary" (ngModelChange)="onTranslationChanged()" placeholder="Summary" rows="2"></textarea>
                  </div>
                  <div class="form-group mb-2">
                    <label>Content</label>
                    <textarea class="form-control" [(ngModel)]="t.content" (ngModelChange)="onTranslationChanged()" placeholder="Content" rows="4"></textarea>
                  </div>
                  <div class="form-group mb-0">
                    <label>Link Button Name</label>
                    <input class="form-control" [(ngModel)]="t.linkButtonName" (ngModelChange)="onTranslationChanged()" placeholder="Link button name" type="text">
                  </div>
                </div>
              }
            </div>
          }
        } @else {
          <h6>Translations <span class="badge bg-info ms-1">From predefined</span></h6>
          @for (t of translations; track t.languageId) {
            <div class="card mb-2">
              <div class="card-header py-2 d-flex justify-content-between align-items-center" style="cursor:pointer" (click)="toggleTranslation(t)">
                <strong>{{ t.languageIso }}</strong>
                <i class="fa" [class.fa-chevron-down]="!t.isCollapsed" [class.fa-chevron-left]="t.isCollapsed"></i>
              </div>
              @if (!t.isCollapsed) {
                <div class="card-body">
                  <div class="form-group mb-2">
                    <label>Title</label>
                    <input class="form-control" [(ngModel)]="t.title" (ngModelChange)="onTranslationChanged()" placeholder="Title" type="text">
                  </div>
                  <div class="form-group mb-2">
                    <label>Summary</label>
                    <textarea class="form-control" [(ngModel)]="t.summary" (ngModelChange)="onTranslationChanged()" placeholder="Summary" rows="2"></textarea>
                  </div>
                  <div class="form-group mb-2">
                    <label>Content</label>
                    <textarea class="form-control" [(ngModel)]="t.content" (ngModelChange)="onTranslationChanged()" placeholder="Content" rows="4"></textarea>
                  </div>
                  <div class="form-group mb-0">
                    <label>Link Button Name</label>
                    <input class="form-control" [(ngModel)]="t.linkButtonName" (ngModelChange)="onTranslationChanged()" placeholder="Link button name" type="text">
                  </div>
                </div>
              }
            </div>
          }
        }
      </div>
      <div class="modal-footer">
        <button [disabled]="isLoading" type="button" class="btn btn-secondary" (click)="modal.hide()">Cancel</button>
        <button [disabled]="isLoading" type="button" class="btn btn-primary" (click)="save()">
          @if (isLoading) { <span class="spinner-border spinner-border-sm me-1"></span> }
          Add
        </button>
      </div>
    </div>
  </div>
</div>
